module.exports = __webpack_public_path__ + "media/images/blogs-bg-b6934614110ce9acc42f664758320dc1.png";